import React from 'react'
import PropTypes from 'prop-types'

import theme from 'theme_'

export default function GeneratorIcon({
  color = theme.colors.beachGrey,
  error = false,
}) {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_16640_381644"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#C4C4C4" />
      </mask>
      <g mask="url(#mask0_16640_381644)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.13339 6.63663H8.79069V5.71822H9.70654V4.7998H4.19922V5.71822H5.13339V6.63663ZM4.19922 19.0233C4.19922 19.2767 4.40464 19.4821 4.65804 19.4821H7.43498C7.55635 19.4821 7.67278 19.4341 7.75878 19.3484L8.39997 18.7097C8.48597 18.6241 8.60239 18.576 8.72377 18.576H15.2912C15.4136 18.576 15.531 18.6249 15.6172 18.7119L16.2454 19.3462C16.3316 19.4332 16.4489 19.4821 16.5714 19.4821H19.3404C19.5938 19.4821 19.7992 19.2767 19.7992 19.0233V17.2286C19.7992 16.9752 19.5938 16.7698 19.3404 16.7698H4.65804C4.40464 16.7698 4.19922 16.9752 4.19922 17.2286V19.0233ZM4.19922 8.01387C4.19922 7.76046 4.40464 7.55504 4.65804 7.55504H19.3404C19.5938 7.55504 19.7992 7.76046 19.7992 8.01387V15.3436C19.7992 15.597 19.5938 15.8024 19.3404 15.8024H4.65804C4.40464 15.8024 4.19922 15.597 4.19922 15.3436V8.01387ZM11.7275 15.0187L14.2919 11.3756C14.3713 11.2654 14.2858 11.1062 14.1515 11.1185H12.8446C12.58 11.1185 12.3703 10.8953 12.3867 10.6312L12.5151 8.5653C12.5274 8.39386 12.3076 8.31426 12.2099 8.45509L9.71875 12.043C9.63937 12.1532 9.72485 12.3063 9.85918 12.3063H11.1478C11.4168 12.3063 11.6281 12.5368 11.6049 12.8048L11.4222 14.9085C11.4039 15.0799 11.6298 15.1595 11.7275 15.0187Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.3878 0.677319C19.5268 0.744571 19.6409 0.851724 19.7146 0.984129L23.9101 8.5241C24.1076 8.87905 23.9704 9.32173 23.6036 9.51285C23.4937 9.57012 23.3708 9.6001 23.246 9.6001H15.1547C14.7381 9.6001 14.4004 9.2733 14.4004 8.87016C14.4004 8.75685 14.4277 8.64508 14.48 8.54373L18.3758 1.00375C18.5621 0.643183 19.0152 0.497033 19.3878 0.677319Z"
          fill="white"
          visibility={error ? 'visible' : 'hidden'}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.3878 0.677319C19.5268 0.744571 19.6409 0.851724 19.7146 0.984129L23.9101 8.5241C24.1076 8.87905 23.9704 9.32173 23.6036 9.51285C23.4937 9.57012 23.3708 9.6001 23.246 9.6001H15.1547C14.7381 9.6001 14.4004 9.2733 14.4004 8.87016C14.4004 8.75685 14.4277 8.64508 14.48 8.54373L18.3758 1.00375C18.5621 0.643183 19.0152 0.497033 19.3878 0.677319ZM19.5432 3.46676H18.5147V6.8001H19.5432V3.46676ZM19.029 7.46676C18.6503 7.46676 18.3432 7.76524 18.3432 8.13343C18.3432 8.50162 18.6503 8.8001 19.029 8.8001C19.4077 8.8001 19.7147 8.50162 19.7147 8.13343C19.7147 7.76524 19.4077 7.46676 19.029 7.46676Z"
          fill={theme.colors.error}
          visibility={error ? 'visible' : 'hidden'}
        />
      </g>
    </svg>
  )
}

GeneratorIcon.propTypes = {
  color: PropTypes.string,
  error: PropTypes.bool,
}
